export const AUTOPLAY_SELECTOR = 'video[autoplay], video[data-play-when-ready]';
export const READY_GATE_ATTRIBUTE = 'data-play-when-ready';

export function isReadyGateClosed(video) {
  return video.hasAttribute(READY_GATE_ATTRIBUTE);
}

export function playVideo(video) {
  const promise = video.play();

  if (promise && typeof promise.catch === 'function') {
    promise.catch(() => {});
  }
}
